import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { ISupplierCategoryApi } from "./base";
import { KeyValue } from "../models/common";
import { Result } from "../models/common/resultResponse";

const baseRoute: string = "SupplierCategory";

export class SupplierCategoryApi extends ISupplierCategoryApi {
	getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/domain`);
	}
}
